import React from 'react'

const SectionSubHeader = ({headerText}) => {
  return (
   <h3 className='volto-subheader'>{headerText}</h3>
  )
}

export default SectionSubHeader
